module.exports = {
          srcSet: __webpack_public_path__ + "public/images/c44941ebde2eadeb760fc4fe28a178f5-800.jpg"+" 800w",
          images:[ {path: __webpack_public_path__ + "public/images/c44941ebde2eadeb760fc4fe28a178f5-800.jpg",width: 800,height: 548}],
          src: __webpack_public_path__ + "public/images/c44941ebde2eadeb760fc4fe28a178f5-800.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/c44941ebde2eadeb760fc4fe28a178f5-800.jpg"},
          
          width: 800,
          height: 548
        }